import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'stringToDate'
})
export class StringToDatePipe implements PipeTransform {

  transform(value: string, inputFormat: string): Date {
    return dayjs(value, inputFormat).toDate();
  }

}
